import { isEmpty, reverse } from 'lodash'
import React, { useMemo } from 'react'
import { CompanyInvestorsViewList } from 'scenes/Dashboard/components/CompanyInvestorsViewList'
import {
  getOrganizationCommittedInvestors,
  getOrganizationInvestorsInCapTable,
  getOrganizationRejectedInvestors,
} from 'scenes/Dashboard/data/organizations/helpers'
import { Organization } from 'scenes/Dashboard/data/organizations/types'
import { getPerformanceIndicatorTextValue } from 'scenes/Dashboard/data/performanceIndicators/helpers'
import { makeStyles } from 'tss-react/mui'

import { List, Theme, Typography } from '@mui/material'

export type DealCardCompanyInvestorsListProps = {
  organization: Organization
}

function getCommittedInvestors(organization: Organization) {
  const committedInvestors = getOrganizationCommittedInvestors(organization)
  return committedInvestors.map(getPerformanceIndicatorTextValue)
}

export const DealCardCompanyInvestorsList = React.memo(({ organization }: DealCardCompanyInvestorsListProps) => {
  const { classes } = useStyles()
  const rejectedInvestors = useMemo(() => getOrganizationRejectedInvestors(organization), [organization])
  const committedInvestors = useMemo(() => reverse(getCommittedInvestors(organization)), [organization])
  const investorsInCapTable = useMemo(() => getOrganizationInvestorsInCapTable(organization), [organization])

  if (isEmpty(rejectedInvestors) && isEmpty(investorsInCapTable) && isEmpty(committedInvestors)) {
    return null
  }
  return (
    <>
      <Typography variant="body2" className={classes.header}>
        Investors
      </Typography>
      <List dense>
        {committedInvestors && (
          <CompanyInvestorsViewList
            investorsTypeLabel="Committed investors current funding round"
            investors={committedInvestors}
          />
        )}
        {rejectedInvestors && (
          <CompanyInvestorsViewList investorsTypeLabel="Reach out / Rejected investors" investors={rejectedInvestors} />
        )}
        {investorsInCapTable && (
          <CompanyInvestorsViewList investorsTypeLabel="Investors in cap table" investors={investorsInCapTable} />
        )}
      </List>
    </>
  )
})

DealCardCompanyInvestorsList.displayName = 'DealCardCompanyInvestorsList'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  header: {
    fontWeight: 'bold',
    marginTop: spacing(2),
  },
}))
